import { render, staticRenderFns } from "./PersonalRequestFields.vue?vue&type=template&id=f1ff7f90"
import script from "./PersonalRequestFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalRequestFields.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports